import { CartItemV2 } from './so';

export enum StatusEnum {
  available = 'available',
  change_other_day = 'change_other_day',
  sold_out = 'sold_out',
  reach_limit = 'reach_limit'
}

export enum CartActivityType {
  cart_deal = 'cart_deal',
  free_shipping = 'free_shipping',
  trade_in = 'trade_in',
  trade_in_new = 'trade_in_new',
  shop_more = 'shop_more'
}

export interface ICartData {
  save_for_later_response: ISave4LaterData;
  invalid_items: any;
  invalid_to_valid_items: any;
  valid_to_invalid_items: any;
  sections: ISectionData[];
  is_record_alcohol: boolean;
  final_amount: string;
  base_final_amount: string;
  coupon_reminder: any;
  coupon_reminder_experiment_result: boolean;
  can_checkout: boolean;
  contain_alcohol: boolean;
  selected_cart_quantity: number;
  selected_item_quantity: number;
  display_save_for_later: boolean;
}

export interface ISave4LaterData {
  page_no: number;
  page_size: number;
  total_count: number;
  items: SaveForLaterItem[];
}

export interface SaveForLaterItem {
  product_key: string;
  refer_type: string;
  status: string;
  title: string;
  img: string;
  price: string;
  base_price: string;
  quantity: number;
}

export interface ISectionData {
  cart_id: string;
  type: string;
  quantity: number;
  tag_info?: any;
  vendor_info?: any;
  shipping_info?: any;
  fee_info?: FeeInfo;
  activity_info?: any;
  items: any;
  shop_more_info?: any;
  selected: boolean;
  sub_type: string;
}

export interface ActivityInfo {
  id: string;
  type: string;
  original_type: string;
  tag: any;
  content: string;
  url: string;
  desc: any;
  limit_amount: number;
  limit_count: any;
  limit_content: string;
  cart_content: string;
  cart_content_enki: any;
  diff_amount: any;
  order_original_amount: number;
  order_final_amount: number;
  is_offer: boolean;
  offer_content: string;
  save_amount: any;
  items: CartItemV2[];
  gift_items: any;
  activity_items: any;
  rule_title_color: string;
  promote_tip_color: string;
  background_color: string;
  rule_show: boolean;
  rule_title: any;
  rule_desc: string;
  source: string;
  icon_type: any;
  limit_time: any;
  use_start_time: any;
  use_end_time: any;
  promo_type: number;
  discount: any;
  discount_price: number;
  max_discount_amount: any;
  order_sku_threshold: any;
  vendor_pay_flat: number;
  vendor_pay_factor: number;
  pc_popup: boolean;
  product_ids: number[];
}

export interface ShippingInfo {
  delivery_mode: string;
  delivery_pickup_date: string;
  estimated_time: string;
  shipping_shipment_date: string;
  delivery_time_id: number;
  original_shipping_free_fee: string;
  shipping_free_fee: string;
  free_shipping_desc: string;
  free_shipping_desc_url: string;
  orignal_shipping_fee: string;
  shipping_fee: string;
  shipping_icon_url: string;
  shipping_type_desc: string;
  shipping_desc: string;
  shipping_delay_desc: string;
  short_shipping_delay_desc: string;
  cold_package_fee: string;
  orignal_cold_package_fee: string;
  free_cold_package_fee: string;
  shipping_fee_type: number;
  delivery_time: string;
  delivery_time_desc: string;
  delivery_content: string;
  shipping_minimum_threshold: string;
  hotdish_wave: string;
  hotdish_delivery_time_content: string;
  pickup_time: string;
  pickup_date: string;
  self_pickup_address: string;
  pick_up_point: string;
  eta_time_content: string;
  is_support_change_date: boolean;
}

export interface FeeInfo {
  sub_total_price: string;
  shipping_fee: string;
  tax: string;
  tip: string;
  service_fee: string;
  points_price: string;
  activity_save_amount: string;
  total_price_with_activity: string;
  coupon_discount: string;
  final_amount: string;
  discount: string;
}
